<div class="ai-audience-container">
  <!-- Left: Chat Section -->
  <div class="ai-chat-section">
    <div class="ai-chat-header" *ngIf="messages.length > 0 || isLoading">
      <app-titan-icon [variant]="'Sparks'" [size]="'l'" class="color-orange-500"></app-titan-icon>
      <span>Audience AI Assistant</span>
    </div>

    <!-- Messages Area -->
    <app-conversation-messages
      [messages]="messages"
      [isLoading]="isLoading"
      [loadingText]="loadingStep"
      (promptSelected)="onPromptSelected($event)"
      (retryMessage)="onRetryMessage($event)">
    </app-conversation-messages>

    <!-- Input Area -->
    <app-chat-input
      [(value)]="userInput"
      [disabled]="isLoading"
      (send)="sendMessage()">
    </app-chat-input>
  </div>

  <!-- Right: Audience Summary Panel -->
  <div class="ai-summary-panel">
    <app-audience-preview
      [audience]="currentAudience"
      [audienceSize]="currentAudienceSize"
      [audienceScore]="currentAudienceScore"
      [onApply]="onApplyClick.bind(this)">
    </app-audience-preview>
  </div>
</div>
